import { Button, Col, Row, Tooltip } from 'antd';
import HTTPService from '../../../utils/makerequest';
import { IPageData } from '../../../interfaces/page-data';
import { useEffect, useRef, useState } from 'react';
import { StateLoader } from '../../../redux/StateLoader';
import { IAuthentication, UserRole } from '../../../interfaces/authentication';
import { Toast } from 'primereact/toast';
import { IDropdownItem } from '../../../AltisComponent/AltisDataGrid';
import '../PrinterManagement/Device.css';
import { useTranslation } from 'react-i18next';
import i18n from '../../../i18n';
import moment from 'moment';
import MUIDataGrid, { IMUIDataGridColumns } from '../../../AltisComponent/MUIDataGrid';
import { FileExcelOutlined, FilePdfOutlined } from '@ant-design/icons';


const InventoryReportCount: React.FunctionComponent<any> = (props) => {
  const { onSetPage } = props;
  const { t } = useTranslation();
  const toast = useRef<any>(null);
  const loader = new StateLoader();
  const userInfo: IAuthentication = loader.loadAuthState();
  // const [inventoryData, setInventoryData] = useState<IInventory>();
  const [filters, setFilters] = useState({ dateProcess: { startDate: null, endDate: null }, dateProcessEnd: { startDate: null, endDate: null }, countingDate: { startDate: null, endDate: null }, completionDate: { startDate: null, endDate: null } });
  const [inventoryData, setInventoryData] = useState({ data: [], count: 0 });
  const [createDate, setCreateDate] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const [inputValueInventory, setInputValueInventory] = useState('');
  const [barcodeValue, setBarcodeValue] = useState('');
  const [selectedValues, setSelectedValues] = useState<number[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const dataGridRef = useRef<any>(null);
  const [selectedFilters, setSelectedFilters] = useState({
    countReport: []
  });
  const [isAll, setIsAll] = useState(false);

  const pageData: IPageData = {
    title: t('countReport'),
    loaded: true,
  };


  useEffect(() => {
    onSetPage(pageData);
    //InventoryCountFilter();
    dataGridRef.current.GetAllData();
  }, [i18n.language]);


  // const handleSelectAll = (e) => {
  //   var details = { ...inventoryData };

  //   if (e.target.checked) {
  //     details.data.map((row) => (row.isSelected = true));
  //   } else {
  //     details.data.map((row) => (row.isSelected = false));
  //   }

  //   setInventoryData(details);
  // };


  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setIsAll(checked);

    const updatedData = inventoryData.data.map((row) => ({
      ...row,
      isSelected: checked,
    }));

    setInventoryData({
      ...inventoryData,
      data: updatedData,
    });
  };


  const handleRowSelect = (e, index) => {
    var newObject = { ...inventoryData };
    newObject.data[index].isSelected = e.target.checked;
    setInventoryData(newObject);

    const selectedRows = newObject.data.filter(row => row.isSelected);
  };


  const handleRowSelection = (newSelection: any) => {
    setSelectedRows(newSelection);
  };


  // const excelDownload = () => {
  //   if (selectedRows.length === 0 && !isAll) {
  //     toast.current?.show({
  //       severity: 'error',
  //       summary: t('mistake'),
  //       detail: t('NoRows'),
  //       life: 3000
  //     });
  //     return;
  //   }

  //   if (isAll == true) {
  //     HTTPService.POSTblobExcel(`/CountingJobInventory/DownloadAllTemplateExcel?isAll=${isAll}`, {})
  //       .then((response) => {
  //         if (response.status === 200) {
  //           toast.current?.show({
  //             severity: 'success',
  //             summary: t('successful'),
  //             detail: t('excelSuccess'),
  //             life: 3000
  //           });
  //         } else if (response.status === 452) {
  //           toast.current?.show({
  //             severity: 'error',
  //             summary: t('mistake'),
  //             detail: t('licenceExpiredDate'),
  //             life: 3000
  //           });
  //         } else if (response.status === 453) {
  //           toast.current?.show({
  //             severity: 'error',
  //             summary: t('mistake'),
  //             detail: t('licenceNotfound'),
  //             life: 3000
  //           });
  //         } else {
  //           toast.current?.show({
  //             severity: 'error',
  //             summary: t('mistake'),
  //             detail: t(response.data),
  //             life: 3000
  //           });
  //         }
  //       })
  //       .catch((err) => {
  //         toast.current?.show({
  //           severity: 'error',
  //           summary: t('mistake'),
  //           detail: t('error'),
  //           life: 3000
  //         });
  //       });
  //   }
  //   // ...existing code...
  // };

  const excelDownload = () => {
    if (!selectedRows || selectedRows.length === 0) {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('NoRows'),
        life: 3000
      });
      return;
    }

    const selectedData = selectedRows.map(row => ({
      barcode: row.customBarcode || row.barcode,
      inventoryName: row.inventoryName,
      campusName: row.campusName,
      locationName: row.locationName,
      companyId: row.companyId,
      companyName: row.companyName,
      itemName: row.itemName,
      countingStatus: t(row.countingStatus),
      countingJobName: row.countingJobName,
      startDate: row.startDate,
      finishDate: row.finishDate,
      countingDate: row.countingDate,
      completionDate: row.completionDate,
      categoryName: row.categoryName,
    }));

    HTTPService.POSTblobExcel('/CountingJobInventory/CountingExcelDownload', selectedData)
      .then((response) => {
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t('excelSuccess'),
            life: 3000
          });
        } else if (response.status === 452) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t('licenceExpiredDate'),
            life: 3000
          });
        } else if (response.status === 453) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t('licenceNotfound'),
            life: 3000
          });
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t(response.data),
            life: 3000
          });
        }
      })
      .catch((err) => {
        console.error('Excel Download Error:', err);
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t('error'),
          life: 3000
        });
      });
  };

  const pdfDownload = () => {
    //const selectedRows = inventoryData.data.filter(row => row.isSelected);
    if (!selectedRows || selectedRows.length === 0) {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('NoRows'),
        life: 3000
      });
      return;
    }

    const selectedData = selectedRows.map(row => (
      ({
        barcode: row.customBarcode || row.barcode,
        inventoryName: row.inventoryName,
        campusName: row.campusName,
        locationName: row.locationName,
        companyId: row.companyId,
        companyName: row.companyName,
        itemName: row.itemName,
        countingStatus: t(row.countingStatus),
        countingJobName: row.countingJobName,
        startDate: row.startDate,
        finishDate: row.finishDate,
        countingDate: row.countingDate,
        completionDate: row.completionDate,
        categoryName: row.categoryName,
      }
      )))


    if (selectedRows.length === 0) {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('NoRows'),
        life: 3000
      });
      return;
    }

    HTTPService.POSTblob('/CountingJobInventory/CountingPdfDownload', selectedData)
      .then((response) => {
        if (response.status === 200) {

          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t('pdfSuccess'),
            life: 3000
          });
        } else if (response.status === 452) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t('licenceExpiredDate'),
            life: 3000
          });
        }
        else if (response.status === 453) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t('licenceNotfound'),
            life: 3000
          });
        }
        else {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t(response.data),
            life: 3000
          });
        }
      })
      .catch((err) => {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t('error'),
          life: 3000
        });
      });
  };

  // const downloadExcel = (isAll) => {
  //   let dataToSend;

  //   if (isAll) {
  //     dataToSend = [];
  //   } else {
  //     const selectedRows = inventoryData.data.filter((row) => row.isSelected);

  //     if (selectedRows.length === 0) {
  //       toast.error(t('NoRows'));
  //       return;
  //     }

  //     dataToSend = selectedRows.map((row) => ({
  //       barcode: row.barcode,
  //       inventoryName: row.inventoryName,
  //       companyId: row.companyId,
  //       companyName: row.companyName,
  //       itemName: row.itemName,
  //       countingStatus: t(row.countingStatus),
  //       countingJobName: row.countingJobName,
  //       startDate: row.startDate,
  //       finishDate: row.finishDate,
  //       countingDate: row.countingDate,
  //       completionDate: row.completionDate,
  //       categoryName: row.categoryName,
  //     }));
  //   }

  //   HTTPService.POSTblobExcel('/CountingJobInventory/DownloadAllTemplateExcel', { isAll, data: dataToSend })
  //   .then((response) => {
  //     if(response.status === 200){
  //     toast.success(t('excelSuccess'));
  //     }else if (response.status === 452){
  //       toast.error(t('licenceExpiredDate'))
  //     }
  //     else if (response.status === 453){
  //       toast.error(t('licenceNotfound'))
  //     }
  //     else {
  //       toast.error(t(response.data))
  //     }
  //     })
  //     .catch((err) => {
  //       toast.error(t('error'));
  //     });
  // };



  const dropdownCountStatus: IDropdownItem[] = [
    { id: 0, name: t('Expired') },
    { id: 1, name: t('In_Progress') },
    { id: 2, name: t('Not_Started') },
    { id: 3, name: t('Completed') },
  ];

  const countingStatus = {
    [t('Expired')]: 0,
    [t('In_Progress')]: 1,
    [t('Not_Started')]: 2,
    [t('Completed')]: 3
  };

  const columns: IMUIDataGridColumns[] = [
    ...(userInfo.role == UserRole.AltisAdmin ? [{
      title: t('Company Name'),
      key: 'companyName',
      placeHolder: t('Company Name'),
      isSorting: true,
    }] : []),
    { title: t('inventoryName'), align: 'left', isSorting: true, key: 'inventoryName', placeHolder: t('inventoryName') },
    { title: t('barcode'), isSorting: true, key: 'customBarcode', placeHolder: t('barcode'), },
    { title: t('Counting Job Name'), isSorting: true, key: 'countingJobName', placeHolder: t('Counting Job Name"') },
    { title: t('Counting Start Date'), isSorting: true, dataType: 'date', key: 'startDate', placeHolder: t('Counting Start Date') },
    { title: t('Counting Finish Date'), isSorting: true, dataType: 'date', key: 'finishDate', placeHolder: t('Counting Finish Date') },
    {
      title: t('countingStatus'), isSorting: true, align: 'left', key: 'countingStatus', placeHolder: t('countingStatus'),
      render: (value) => {
        return <div style={{ textAlign: 'left', marginLeft: '5px' }}>{t(value)}</div>;
      }, enumValues: countingStatus,
    },
    { title: t('countingDate'), isSorting: true, align: 'center', dataType: 'date', key: 'countingDate', placeHolder: t('countingDate') },
    { title: t('completionDate'), isSorting: true, key: 'completionDate', dataType: 'date', placeHolder: t('completionDate') },
  ];

  const InventoryCountFilter = (e?) => {
    const filters = e?.filters;

    const dateFieldsMap = {
      startDate: ['startDate_start', 'startDate_Finish'],
      finishDate: ['finishDate_Start', 'finishDate_Finish'],
      countingDate: ['countingStartDate', 'countingEndDate'],
      completionDate: ['completionStartDate', 'completionEndDate']
    };

    for (const [key, [startKey, endKey]] of Object.entries(dateFieldsMap)) {
      if (filters?.[key] && Array.isArray(filters[key])) {
        const [startDate, endDate] = filters[key];
        filters[startKey] = startDate;
        filters[endKey] = endDate;
        delete filters[key];
      }
    }

    if (filters?.countingStatus !== undefined) {
      if (filters.countingStatus === "" || filters.countingStatus === null) {
        delete filters.countingStatus;
      } else {
        filters.countingStatus = [Number(filters.countingStatus)];
      }
    }

    const body = {
      sortColumn: e?.sortField,
      sortOrder: e?.sortOrder || 'asc',
      pageSize: e?.pageSize,
      page: e?.page,
      ...filters
    };

    HTTPService.POST(`/CountingJobInventory/filtersCounting`, body).then((response) => {
      if (!response.data) return;
      if (response.status === 200) {
        setInventoryData({
          data: response.data.data,
          count: response.data.count
        });
      } else {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t(response.data),
          life: 3000
        });
      }
    });
  };

  const handleSearch = () => {
    const filterData = {
      ...filters,
      pageSize: 10,
      page: 1,
      countingStatus: selectedValues,
      countingJobName: inputValue,
      count: selectedFilters.countReport,
      inventoryName: inputValueInventory,
      barcode: barcodeValue
    };
    InventoryCountFilter(filterData);
  };


  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleInputChangeInventory = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValueInventory(e.target.value);
  };


  const handleDateChange = (dates, type) => {

    if (!dates) {
      setFilters(prev => ({
        ...prev,
        [type]: { startDate: null, endDate: null }
      }));
      return;
    }

    const [startDate, endDate] = dates;

    const formattedStartDate = startDate ? moment(startDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ') : null;
    const formattedEndDate = endDate ? moment(endDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ') : null;

    setFilters(prev => ({
      ...prev,
      [type]: {
        startDate: formattedStartDate,
        endDate: formattedEndDate
      }
    }));

  };


  const handleCheckboxChange = (value: number) => {
    setSelectedValues((prev) => {
      if (prev.includes(value)) {
        return prev.filter((v) => v !== value);
      } else {
        return [...prev, value];
      }
    })
  };




  const handleFilterChange = (filterType: keyof typeof selectedFilters, id: number) => {
    const newSelectedFilters = {
      ...selectedFilters,
      [filterType]: selectedFilters[filterType].includes(id)
        ? selectedFilters[filterType].filter(item => item !== id)
        : [...selectedFilters[filterType], id]
    };

    setSelectedFilters(newSelectedFilters);


    if (filterType === 'countReport') {
      InventoryCountFilter({ countingStatus: newSelectedFilters.countReport });
    }

  };

  const InventoryPostCountFilter = (object) => {
    HTTPService.POST(`/CountingJobInventory/filtersCounting`, object).then((response) => {
      if (!response.data) {
        return;
      }
      if (response.status === 200) {
        setInventoryData(response.data);
      } else if (response.status === 400) {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t(response.data),
          life: 3000
        });
      } else {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: response.data,
          life: 3000
        });
      }
    });
  }

  const clearFilters = () => {
    const filterData = {
      ...filters,
      pageSize: 10,
      page: 1,
    };

    setSelectedValues([])
    setInputValue('')
    setInputValueInventory('')
    setBarcodeValue('')
    setCreateDate([])

    InventoryPostCountFilter(filterData)
  };


  const handleBarcodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const trim = e.target.value.trim()
    setBarcodeValue(trim);
  };


  return (
    <>
      <Toast ref={toast} />
      <Row gutter={16} style={{ marginTop: '20px' }}>
        <Col xs={24} sm={8} md={6} lg={4} xl={4} style={{ paddingLeft: '8px' }}>
          {/* <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '5px',
            padding: '5px 10px',
            border: '1px solid #d9d9d9',
            borderRadius: '5px',
            backgroundColor: 'white',
            marginTop: '70px'
          }}>
            <span style={{
              flexGrow: 1,
              textAlign: 'center',
              fontWeight: 'bold',
              fontSize: '14px',
              color: '#333'
            }}>
              {t('noFilter')}
            </span>
            <CloseOutlined
              onClick={clearFilters}
              style={{ cursor: 'pointer', color: 'black', fontSize: '16px' }}
            />
          </div> */}

          {/* <ConfigProvider locale={trTR}>
          <Collapse style={{ 
            width: '100%', 
            maxWidth: '220px', 
            marginTop: '20px', 
            border: 'none' 
          }}>

            <Collapse.Panel header={t('Counting Job Name')} key="1">

                  <div>
                    <Input
                      name='Counting Job Name'
                      type="text"
                      value={inputValue}
                      onChange={handleInputChange}
                      placeholder={t('Counting Job Name')}
                    />
                  </div>

            </Collapse.Panel>

            <Collapse.Panel header={t('inventoryName')} key="2">
              <div>
                <Input
                  name='inventoryName'
                  type="text"
                  value={inputValueInventory}
                  onChange={handleInputChangeInventory}
                  placeholder={t('inventoryName')}
                />
              </div>

            </Collapse.Panel>

            <Collapse.Panel header={t('countingStatus')} key="3">
              <div>
                <Checkbox
                  value={0}
                  checked={selectedValues.includes(0)}
                  onChange={() => handleCheckboxChange(0)}
                  style={{ marginLeft: '8px' }}
                >
                  {t('Expired')}
                </Checkbox>
                <Checkbox
                  value={1}
                  checked={selectedValues.includes(1)}
                  onChange={() => handleCheckboxChange(1)}
                >
                  {t('In_Progress')}
                </Checkbox>
                <Checkbox
                  value={2}
                  checked={selectedValues.includes(2)}
                  onChange={() => handleCheckboxChange(2)}
                >
                  {t('Not_Started')}
                </Checkbox>
                <Checkbox
                  value={3}
                  checked={selectedValues.includes(3)}
                  onChange={() => handleCheckboxChange(3)}
                >
                  {t('Completed')}
                </Checkbox>
              </div>
            </Collapse.Panel>


            <Collapse.Panel header={t('barcode')} key="4">

              <div>
                <Input
                  name='barcode'
                  type="text"
                  value={barcodeValue}
                  onChange={handleBarcodeChange}
                  placeholder={t('barcode')}
                />
              </div>
            </Collapse.Panel>
            
            <Panel header={t('dateProcess')} key="10">
              <DatePicker.RangePicker onChange={(dates) => handleDateChange(dates, 'dateProcess')}  format={'DD/MM/YYYY HH:mm'} showTime style={{ width: '100%' }} />
            </Panel>

            <Panel header={t('dateProcessEnd')} key="11">
              <DatePicker.RangePicker onChange={(dates) => handleDateChange(dates, 'dateProcessEnd')} format={'DD/MM/YYYY HH:mm'} showTime style={{ width: '100%' }} />
            </Panel>

            <Panel header={t('countingDate')} key="12">
              <DatePicker.RangePicker onChange={(dates) => handleDateChange(dates, 'countingDate')} format={'DD/MM/YYYY HH:mm'} showTime style={{ width: '100%' }} />
            </Panel>

            <Panel header={t('completionDate')} key="13">
              <DatePicker.RangePicker onChange={(dates) => handleDateChange(dates, 'completionDate')} format={'DD/MM/YYYY HH:mm'} showTime style={{ width: '100%' }} />
            </Panel>

          </Collapse>
        </ConfigProvider>
          <Button type="primary" style={{ marginTop: '10px', width: '100%',maxWidth:'200px' }} onClick={InventoryCountFilter}>
            {t('search')}
          </Button> */}
        </Col>

        <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ paddingLeft: '8px' }}>
          <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
            <Tooltip title={t('Excel')}>
              <Button
                type="primary"
                shape="round"
                onClick={excelDownload}
                style={{
                  height: 64,
                  width: 'auto',
                  backgroundColor: 'transparent',
                  color: '#1890ff',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginLeft: '20px',
                  padding: 0,
                  border: 'none',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.boxShadow = '8px 15px rgba(0,0,0,0.1)';
                  e.currentTarget.style.color = '#40a9ff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.color = '#1890ff';
                }}
              >
                <FileExcelOutlined style={{ fontSize: 24 }} />
                <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                  {t('Excel')}
                </span>
              </Button>
            </Tooltip>
            <Tooltip title={t('PDF')}>
              <Button
                type="primary"
                shape="round"
                onClick={pdfDownload}
                style={{
                  height: 64,
                  width: 'auto',
                  backgroundColor: 'transparent',
                  color: '#1890ff',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginLeft: '40px',
                  padding: 0,
                  border: 'none',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.boxShadow = '8px 15px rgba(0,0,0,0.1)';
                  e.currentTarget.style.color = '#40a9ff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.color = '#1890ff';
                }}
              >
                <FilePdfOutlined style={{ fontSize: 24 }} />
                <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                  {t('PDF')}
                </span>
              </Button>
            </Tooltip>
          </div>

          {/* DataGrid */}
          <div style={{ width: '100%' }}>
            <MUIDataGrid
              ref={dataGridRef}
              columns={columns}
              enableSelection={true}
              onChange={InventoryCountFilter}
              filterMode='server'
              onSelectionChange={handleRowSelection}
              data={inventoryData?.data}
              total={inventoryData?.count}
            />
          </div>
        </Col>
      </Row>
    </>
  );



};

export default InventoryReportCount;
